import { createAction, createReducer, isActionOf } from 'typesafe-actions'
import { combineReducers } from 'redux'
import { payloadReducer } from '../../utils/redux-utils'
import { RootEpic } from '../root'
import { delay, filter, map, mergeMapTo, switchMap, take, tap } from 'rxjs/operators'
import { EMPTY, merge, of } from 'rxjs'
import { errorToast } from '../../components/controls/Toaster/Toaster'
import { parseDate } from '../../utils/date-utils'
import { isDefined } from '../../utils/utils'
import { differenceInMilliseconds } from 'date-fns'
import { MESSAGES } from '../../constants/messages'

const actions = {
    setAsideRatio: createAction('@SYSTEM/SET_ASIDE_RATIO')<number>(),
    startUpdate: createAction('@SYSTEM/START_UPDATE')<string>(),
    finishUpdate: createAction('@SYSTEM/FINISH_UPDATE')<string>(),
}

export { actions as systemActions }

export interface SystemState {
    asideRatio: number,
    updateAt: string,
}

export const systemReducer = combineReducers<SystemState>({
    asideRatio: createReducer(0.3)
        .handleAction(actions.setAsideRatio, payloadReducer),
    updateAt: createReducer('')
        .handleAction(actions.startUpdate, payloadReducer),
})

const update: RootEpic = action$ => action$.pipe(
    filter(isActionOf(actions.startUpdate)),
    map(action => parseDate(action.payload)),
    filter(isDefined),
    switchMap(updateAt => {
        errorToast(MESSAGES.UPDATE_WARNING(updateAt.toISOString()))
        return merge(
            of(updateAt).pipe(delay(differenceInMilliseconds(updateAt, new Date()))),
            action$.pipe(filter(isActionOf(actions.finishUpdate))),
        ).pipe(
            take(1),
            tap(() => location.reload()),
            mergeMapTo(EMPTY),
        )
    })
)

export const systemEpic = update